import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const navLinks = [
  { label: 'What We Do', href: '/#features' },
  { label: 'Who We Serve', href: '/#who' },
  { label: 'Articles', to: '/articles' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact', href: '/#contact' },
];

export default function Header({ active }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <img src="/logo.png" alt="Civic Rentals LLC Logo" className="h-10 w-auto object-contain" />
          <span className="text-2xl font-bold text-slate-900">Civic Rentals LLC</span>
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) =>
            link.to ? (
              <Link
                key={link.label}
                to={link.to}
                className={active === link.label ? 'text-blue-600 font-semibold' : 'text-slate-600 hover:text-blue-600 transition-colors font-medium'}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className={active === link.label ? 'text-blue-600 font-semibold' : 'text-slate-600 hover:text-blue-600 transition-colors font-medium'}
              >
                {link.label}
              </a>
            )
          )}
          <Button onClick={() => { navigate('/'); setTimeout(() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' }), 300); }}>
            Request Demo
          </Button>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 text-slate-700"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="md:hidden bg-white border-t border-slate-200 px-6 py-4 space-y-3" data-testid="mobile-menu">
          {navLinks.map((link) =>
            link.to ? (
              <Link
                key={link.label}
                to={link.to}
                className={`block py-2 font-medium ${active === link.label ? 'text-blue-600' : 'text-slate-700'}`}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className={`block py-2 font-medium ${active === link.label ? 'text-blue-600' : 'text-slate-700'}`}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </a>
            )
          )}
          <Button
            className="w-full mt-2"
            onClick={() => { setOpen(false); navigate('/'); setTimeout(() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' }), 300); }}
          >
            Request Demo
          </Button>
        </nav>
      )}
    </header>
  );
}
